export default __webpack_public_path__ + "empty@3x.2c405741.jpg";